import { DemoRequest } from '@/app/components/DemoRequest/DemoRequest'
import type { DemoForm as DemoFormProps } from '@/sanity.types'

type DemoFormSectionProps = {
  block: DemoFormProps & { _key?: string }
  index: number
  pageId?: string
  pageType?: string
}

export default function DemoFormSection({ block, pageId, pageType }: DemoFormSectionProps) {
  return (
    <DemoRequest
      demoForm={block}
      documentId={pageId}
      documentType={pageType}
      parentPath="pageBuilder"
    />
  )
}
